export const firebaseConfig = {
    apiKey: "AIzaSyC0Px3QteTSyfw6BtYc4Hl6aBEF8UbY_3Y",
    authDomain: "docib-online---ga4.firebaseapp.com",
    projectId: "docib-online---ga4",
    storageBucket: "docib-online---ga4.appspot.com",
    messagingSenderId: "900610254478",
    appId: "1:900610254478:web:ed5803e8d5acde80894bdf",
    measurementId: "G-S9WBSQMSVM"
};
